<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{  "Modifier l'engagement AH" }}</h1>
      <b-button
        size="sm"
        variant="danger"
        class="button-danger-style ml-2 float-right mb-2"
        @click="goBack"
      >
        <font-awesome-icon icon="arrow-left" /> {{ "Retour" }}
      </b-button>
    </div>
    <div class="content">
      <b-card>
        <form @submit.prevent="handleSubmit">
          <b-form-group :label="$t('Date d’engagement') + '*'">
            <b-form-input
              type="date"
              v-model="formData.dateEngagement"
              :state="validateState('dateEngagement')"
              required
            ></b-form-input>
            <error-handle
              :list="v$.formData.dateEngagement.$errors"
              id="dateEngagement-feedback"
            ></error-handle>
          </b-form-group>
       
          <b-form-group :label="$t('Date prévue de réalisation') + '*'">
            <b-form-input
              type="date"
              v-model="formData.datePrevuRealisation"
              :state="validateState('datePrevuRealisation')"
              required
            ></b-form-input>
            <error-handle
              :list="v$.formData.datePrevuRealisation.$errors"
              id="datePrevuRealisation-feedback"
            ></error-handle>
          </b-form-group>
          <b-form-group 
            v-if="isSuperAdmin && ahData && ahData.devis && ahData.devis.entreprise" 
            :label="$t('ENTREPRISES')"
          >
            <b-form-input
              :value="ahData.devis.entreprise.lib || '-'"
              readonly
              plaintext
            ></b-form-input>
          </b-form-group>
          <b-form-group :label="$t('FACTURE')">
            <b-form-input
              :value="factureNumberDisplay"
              readonly
              plaintext
            ></b-form-input>
          </b-form-group>
          
            <!-- Conditional Forms based on existing relations -->
            <div v-if="selectedFactureGroups.length > 0" class="conditional-forms mt-4">
              <!-- Use tabs if multiple forms, otherwise display directly -->
              <b-tabs v-if="selectedFactureGroups.length > 1" v-model="activeTab" content-class="mt-3">
                <b-tab
                  v-for="(group, index) in selectedFactureGroups"
                  :key="`tab-${group.id}-${index}`"
                  :title="getGroupLabel(group.type_group)"
                  :active="index === 0"
                >
                  <div class="form-group-section">
                    <!-- BAR-EN-101: Isolation de combles ou de toiture -->
                    <div v-if="group.type_group === 'BAR-EN-101'">
                      <b-form-group>
                        <template #label>
                          {{ $t('Nécessite_pare-vapeur') }}
                        </template>
                        <b-form-checkbox
                          v-model="groupFormData[group.id].necessite_pare_vapeur"
                          :value="1"
                          :unchecked-value="0"
                        >
                          {{ $t("Nécessite_pare-vapeur") }}
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group :label="$t('type_isolation') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].type_pose"
                          :options="typePoseOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].type_isolant"
                          :options="typeIsolantOptions"
                          @change="updateNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].norme"
                          :options="getNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('surface_isolant') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_isolant"
                          :placeholder="$t('surface_isolant')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('resistance_thermique') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].resistance_thermique"
                          :placeholder="$t('resistance_thermique')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('epaisseur') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].epaisseur"
                          :placeholder="$t('epaisseur')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-EN-102: Isolation des murs -->
                    <div v-if="group.type_group === 'BAR-EN-102'">
                      <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].type_isolant"
                          :options="typeIsolantOptions"
                          @change="updateNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].norme"
                          :options="getNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('surface_isolant') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].Surface_isolant"
                          :placeholder="$t('surface_isolant')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('resistance_thermique') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].resistance_thermique"
                          :placeholder="$t('resistance_thermique')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('epaisseur') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].epaisseur"
                          :placeholder="$t('epaisseur')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-EN-103: Isolation d'un plancher -->
                    <div v-if="group.type_group === 'BAR-EN-103'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Protéger les matériaux d'isolation contre l'humidité par") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].protection_type"
                          :options="protectionOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].type_isolant"
                          :options="typeIsolantOptions"
                          @change="updateNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].norme"
                          :options="getNormeOptions(group.id)"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('surface_isolant') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].Surface_isolant"
                          :placeholder="$t('surface_isolant')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('resistance_thermique') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].resistance_thermique"
                          :placeholder="$t('resistance_thermique')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('epaisseur') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].epaisseur"
                          :placeholder="$t('epaisseur')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-EN-104: Fenêtre ou porte-fenêtre complète avec vitrage isolant -->
                    <div v-if="group.type_group === 'BAR-EN-104'">
                      <b-form-group :label="$t('type_fenetre') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].type_fenetre"
                          :options="typeFenetreOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('nombre_fenetres') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].nombre_fenetres"
                          :placeholder="$t('nombre_fenetres')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('surface') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_totale"
                          :placeholder="$t('surface')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('coefficient_transmission') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].coefficient_transmission"
                          :placeholder="$t('coefficient_transmission')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('facteur_solaire') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].facteur_solaire"
                          :placeholder="$t('facteur_solaire')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-127: Ventilation mécanique simple flux hygroréglable -->
                    <div v-if="group.type_group === 'BAR-TH-127'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type d'installation") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].type_installation"
                          :options="installationTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <div v-if="groupFormData[group.id].type_installation === 'Installation collective'">
                        <b-form-group>
                          <template #label>
                            {{ $t("Type de ventilation") }}
                          </template>
                          <b-form-radio-group
                            v-model="groupFormData[group.id].type_ventilation"
                            :options="ventilationTypeOptions"
                          >
                          </b-form-radio-group>
                        </b-form-group>
                        <b-form-group :label="$t('nombre_logements') + '*'">
                          <b-form-input
                            type="number"
                            min="0"
                            v-model="groupFormData[group.id].nombre_logements"
                            :placeholder="$t('nombre_logements')"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div v-if="groupFormData[group.id].type_installation === 'Installation individuelle'">
                        <b-form-group :label="$t('surface') + '*'">
                          <b-form-input
                            type="number"
                            min="0"
                            v-model="groupFormData[group.id].surface_habitable"
                            :placeholder="$t('surface')"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group :label="$t('classe') + '*'">
                          <b-form-input
                            type="text"
                            v-model="groupFormData[group.id].classe_energetique"
                            :placeholder="$t('classe')"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <b-form-group :label="$t('Puissance') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          step="0.01"
                          v-model="groupFormData[group.id].puissance_electrique"
                          :placeholder="$t('Puissance')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-148: Chauffe-eau thermodynamique à accumulation -->
                    <div v-if="group.type_group === 'BAR-TH-148'">
                      <b-form-group :label="$t('type_installation')">
                        <b-form-select
                          v-model="groupFormData[group.id].type_installation"
                          :options="typeInstallationOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('COP') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].cop"
                          :placeholder="$t('COP')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-143: Système solaire -->
                    <div v-if="group.type_group === 'BAR-TH-143'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type de certification") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].certification_type"
                          :options="certificationTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <div v-if="groupFormData[group.id].certification_type === 'certification'">
                        <b-form-group>
                          <template #label>
                            {{ $t("Type de norme") }}
                          </template>
                          <b-form-radio-group
                            v-model="groupFormData[group.id].norme_type"
                            :options="normeTypeOptions"
                          >
                          </b-form-radio-group>
                        </b-form-group>
                        <b-form-group :label="$t('NOM_CERTIF') + '*'">
                          <b-form-input
                            type="text"
                            v-model="groupFormData[group.id].certification"
                            :placeholder="$t('NOM_CERTIF')"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group v-if="groupFormData[group.id].norme_type === 'autres'" :label="$t('NORM') + '*'">
                          <b-form-input
                            type="text"
                            v-model="groupFormData[group.id].norme"
                            :placeholder="$t('NORM')"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <b-form-group :label="$t('FLUIDE') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].nature_fluide"
                          :placeholder="$t('FLUIDE')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Productivité')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].productivite"
                          :placeholder="$t('Productivité')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Surface_chauffe')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_chaufe"
                          :placeholder="$t('Surface_chauffe')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Surface_hors_tout')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_hors_tout"
                          :placeholder="$t('Surface_hors_tout')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Capacite_stockage')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].capacite_stockage"
                          :placeholder="$t('Capacite_stockage')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Classe_efficacite_energetique')">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].classe_efficacite_energetique"
                          :placeholder="$t('Classe_efficacite_energetique')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-171: Pompe à chaleur de type air/eau -->
                    <div v-if="group.type_group === 'BAR-TH-171'">
                      <b-form-group :label="$t('Type_pompe') + '*'">
                        <b-form-select
                          v-model="groupFormData[group.id].denomination_temperature"
                          :options="pompeTypeOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('Coeffcient_performance') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          step="0.01"
                          v-model="groupFormData[group.id].coefficient_performance"
                          :placeholder="$t('Coeffcient_performance')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Efficacité_calculer_selon_réglément') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].efficacite"
                          :placeholder="$t('Efficacité')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Surface_chauffe') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_chauffee"
                          :placeholder="$t('Surface_chauffe')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Régulateur') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].regulateur_classe"
                          :placeholder="$t('Régulateur')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-129: Pompe à chaleur de type air/air -->
                    <div v-if="group.type_group === 'BAR-TH-129'">
                      <b-form-group :label="$t('Coeffcient_performance') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].coefficient_performance_saisonnier"
                          :placeholder="$t('Coeffcient_performance')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Puissance') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].puissance_nominale"
                          :placeholder="$t('Puissance')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('SURFACE') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_chauffee"
                          :placeholder="$t('SURFACE')"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-137: Raccordement au réseau de chaleur -->
                    <div v-if="group.type_group === 'BAR-TH-137'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Raccordé au réseau de chaleur") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].deja_raccorder"
                          :options="raccordeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <div v-if="groupFormData[group.id].deja_raccorder === true">
                        <b-form-group>
                          <template #label>
                            {{ $t("Raccordement") }}
                          </template>
                          <b-form-radio-group
                            v-model="groupFormData[group.id].existe_cetificat_economie"
                            :options="certificatOptions"
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                      <b-form-group v-if="getLogementType() === 'Maison individuelle'" :label="$t('Surface habitable (m²)')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_habitable"
                          placeholder="Surface en m²"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group v-if="getLogementType() === 'Collectif' || getLogementType() === 'Appartement'" :label="$t('nbr_appartements')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].nbr_appartements"
                          :placeholder="$t('nbr_appartements')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('Nom du réseau')">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].nom_reseau"
                          placeholder="Nom du réseau"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>

                    <!-- BAR-TH-173: Système de régulation horaire -->
                    <div v-if="group.type_group === 'BAR-TH-173'">
                      <b-form-group :label="$t('Le type de système concerné')">
                        <b-form-select
                          v-model="groupFormData[group.id].concerne"
                          :options="concerneOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('Classe de régulation')">
                        <b-form-select
                          v-model="groupFormData[group.id].class"
                          :options="classOptions"
                        >
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :label="$t('L\'ancien système est de classe C')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].ancient_system_class_c"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('les pièces sont équipées d\'émetteurs')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].pieces_equipees_emetteur"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Dispositif central')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].comporte_appareil_central"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('dispose d\'une sonde de mesure')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].dispose_sonde_mesure"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('équipé d\'un dispositif de régulation')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].possede_dispositif_regulant"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('fonctionner localement au minimum')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].effectuer_local_minima"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Dérogation locale possible')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].deroger_localement_consignes"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Possibilité de fonctionnement en cas de perte de connexion')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].fonctionner_perte_connexion"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('le boîtier est équipé d\'émetteurs')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].logement_equipees_emetteur"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Planchers/Plafonds chauffants')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].planchers_plafonds_chauffants"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Remplacement du système existant')">
                        <b-form-radio-group
                          v-model="groupFormData[group.id].remlpacement"
                          :options="booleanOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('Surface habitable (m²)')">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_chauffe"
                          placeholder="Surface en m²"
                        ></b-form-input>
                      </b-form-group>
                      
                      <b-form-group :label="$t('Données supplémentaires')">
                        <vue-editor
                          v-model="groupFormData[group.id].donnees_supplementaires"
                          :editor-toolbar="customToolbar"
                          class="mt-2"
                          :placeholder="$t('Ajouter des données supplémentaires')"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              
              <!-- Single form without tabs -->
              <div v-else class="form-group-section">
                <div
                  v-for="(group, index) in selectedFactureGroups"
                  :key="index"
                >
                  <div class="group-header mb-3">
                    <h4>{{ getGroupLabel(group.type_group) }}</h4>
                  </div>
                  
                  <!-- BAR-EN-101: Isolation de combles ou de toiture -->
                  <div v-if="group.type_group === 'BAR-EN-101'">
                    <b-form-group>
                      <template #label>
                        {{ $t('Nécessite_pare-vapeur') }}
                      </template>
                      <b-form-checkbox
                        v-model="groupFormData[group.id].necessite_pare_vapeur"
                        :value="1"
                        :unchecked-value="0"
                      >
                        {{ $t("Nécessite_pare-vapeur") }}
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="$t('type_isolation') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_pose"
                        :options="typePoseOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-102: Isolation des murs -->
                  <div v-if="group.type_group === 'BAR-EN-102'">
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].Surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-103: Isolation d'un plancher -->
                  <div v-if="group.type_group === 'BAR-EN-103'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Protéger les matériaux d'isolation contre l'humidité par") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].protection_type"
                        :options="protectionOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].Surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-104: Fenêtre ou porte-fenêtre complète avec vitrage isolant -->
                  <div v-if="group.type_group === 'BAR-EN-104'">
                    <b-form-group :label="$t('type_fenetre') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_fenetre"
                        :options="typeFenetreOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('nombre_fenetres') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].nombre_fenetres"
                        :placeholder="$t('nombre_fenetres')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('surface') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_totale"
                        :placeholder="$t('surface')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('coefficient_transmission') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].coefficient_transmission"
                        :placeholder="$t('coefficient_transmission')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('facteur_solaire') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].facteur_solaire"
                        :placeholder="$t('facteur_solaire')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-127: Ventilation mécanique simple flux hygroréglable -->
                  <div v-if="group.type_group === 'BAR-TH-127'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Type d'installation") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].type_installation"
                        :options="installationTypeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].type_installation === 'Installation collective'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type de ventilation") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].type_ventilation"
                          :options="ventilationTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('nombre_logements') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].nombre_logements"
                          :placeholder="$t('nombre_logements')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div v-if="groupFormData[group.id].type_installation === 'Installation individuelle'">
                      <b-form-group :label="$t('surface') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_habitable"
                          :placeholder="$t('surface')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('classe') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].classe_energetique"
                          :placeholder="$t('classe')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <b-form-group :label="$t('Puissance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        step="0.01"
                        v-model="groupFormData[group.id].puissance_electrique"
                        :placeholder="$t('Puissance')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-148: Chauffe-eau thermodynamique à accumulation -->
                  <div v-if="group.type_group === 'BAR-TH-148'">
                    <b-form-group :label="$t('type_installation')">
                      <b-form-select
                        v-model="groupFormData[group.id].type_installation"
                        :options="typeInstallationOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('COP') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].cop"
                        :placeholder="$t('COP')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-143: Système solaire -->
                  <div v-if="group.type_group === 'BAR-TH-143'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Type de certification") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].certification_type"
                        :options="certificationTypeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].certification_type === 'certification'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type de norme") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].norme_type"
                          :options="normeTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('NOM_CERTIF') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].certification"
                          :placeholder="$t('NOM_CERTIF')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group v-if="groupFormData[group.id].norme_type === 'autres'" :label="$t('NORM') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].norme"
                          :placeholder="$t('NORM')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <b-form-group :label="$t('FLUIDE') + '*'">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].nature_fluide"
                        :placeholder="$t('FLUIDE')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Productivité')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].productivite"
                        :placeholder="$t('Productivité')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_chauffe')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chaufe"
                        :placeholder="$t('Surface_chauffe')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_hors_tout')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_hors_tout"
                        :placeholder="$t('Surface_hors_tout')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Capacite_stockage')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].capacite_stockage"
                        :placeholder="$t('Capacite_stockage')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Classe_efficacite_energetique')">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].classe_efficacite_energetique"
                        :placeholder="$t('Classe_efficacite_energetique')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-171: Pompe à chaleur de type air/eau -->
                  <div v-if="group.type_group === 'BAR-TH-171'">
                    <b-form-group :label="$t('Type_pompe') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].denomination_temperature"
                        :options="pompeTypeOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Coeffcient_performance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        step="0.01"
                        v-model="groupFormData[group.id].coefficient_performance"
                        :placeholder="$t('Coeffcient_performance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Efficacité_calculer_selon_réglément') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].efficacite"
                        :placeholder="$t('Efficacité')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_chauffe') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffee"
                        :placeholder="$t('Surface_chauffe')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Régulateur') + '*'">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].regulateur_classe"
                        :placeholder="$t('Régulateur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-129: Pompe à chaleur de type air/air -->
                  <div v-if="group.type_group === 'BAR-TH-129'">
                    <b-form-group :label="$t('Coeffcient_performance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].coefficient_performance_saisonnier"
                        :placeholder="$t('Coeffcient_performance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Puissance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].puissance_nominale"
                        :placeholder="$t('Puissance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('SURFACE') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffee"
                        :placeholder="$t('SURFACE')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-137: Raccordement au réseau de chaleur -->
                  <div v-if="group.type_group === 'BAR-TH-137'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Raccordé au réseau de chaleur") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].deja_raccorder"
                        :options="raccordeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].deja_raccorder === true">
                      <b-form-group>
                        <template #label>
                          {{ $t("Raccordement") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].existe_cetificat_economie"
                          :options="certificatOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                    <b-form-group v-if="getLogementType() === 'Maison individuelle'" :label="$t('Surface habitable (m²)')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_habitable"
                        placeholder="Surface en m²"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="getLogementType() === 'Collectif' || getLogementType() === 'Appartement'" :label="$t('nbr_appartements')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].nbr_appartements"
                        :placeholder="$t('nbr_appartements')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Nom du réseau')">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].nom_reseau"
                        placeholder="Nom du réseau"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-173: Système de régulation horaire -->
                  <div v-if="group.type_group === 'BAR-TH-173'">
                    <b-form-group :label="$t('Le type de système concerné')">
                      <b-form-select
                        v-model="groupFormData[group.id].concerne"
                        :options="concerneOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Classe de régulation')">
                      <b-form-select
                        v-model="groupFormData[group.id].class"
                        :options="classOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('L\'ancien système est de classe C')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].ancient_system_class_c"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('les pièces sont équipées d\'émetteurs')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].pieces_equipees_emetteur"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Dispositif central')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].comporte_appareil_central"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('dispose d\'une sonde de mesure')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].dispose_sonde_mesure"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('équipé d\'un dispositif de régulation')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].possede_dispositif_regulant"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('fonctionner localement au minimum')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].effectuer_local_minima"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Dérogation locale possible')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].deroger_localement_consignes"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Possibilité de fonctionnement en cas de perte de connexion')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].fonctionner_perte_connexion"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('le boîtier est équipé d\'émetteurs')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].logement_equipees_emetteur"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Planchers/Plafonds chauffants')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].planchers_plafonds_chauffants"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Remplacement du système existant')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].remlpacement"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Surface habitable (m²)')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffe"
                        placeholder="Surface en m²"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>

              

          <b-form-group :label="$t('Attestation sur le bonheur - Bénéficiaire')">
            <vue-editor
              v-model="formData.attestationBeneficiaire"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Attestation sur le bonheur pour le bénéficiaire')"
            />
          </b-form-group>

          <b-form-group :label="$t('Attestation sur le bonheur - Professionnel')">
            <vue-editor
              v-model="formData.attestationProfessionnel"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Attestation sur le bonheur pour le professionnel')"
            />
          </b-form-group>
          <!-- Affichage des informations de la facture sélectionnée -->
          <b-form-group :label="$t('Mentions finales')">
            <vue-editor
              v-model="formData.mentionsFinales"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Mentions finales')"
            />
          </b-form-group>

          <div class="form-actions">
            <b-button variant="danger" @click="goBack" class="mr-2">
              {{ $t("CANCEL") }}
            </b-button>
            <b-button
              variant="success"
              type="submit"
              :disabled="getdevisLoading || getAHLoading"
            >
              {{ $t("SAVE") }}
              <b-spinner
                v-if="getdevisLoading || getAHLoading"
                small
                variant="light"
                class="ml-2"
              ></b-spinner>
            </b-button>
          </div>
        </form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import errorHandle from "../components/ui/errorHandle.vue";

export default {
  components: {
    errorHandle,
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      formData: {
        dateEngagement: null,
        factureId: null,
        datePrevuRealisation: null,
        mentionsFinales: "",
        attestationBeneficiaire: "",
        attestationProfessionnel: "",
      },
      ahId: null,
      selectedEntreprise: null,
      ahData: null, // Store full AH data for relations
      selectedFactureGroups: [], // Virtual groups based on existing relations
      groupFormData: {}, // Form data for each group
      activeTab: 0,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      // Options pour les formulaires (same as createAH)
      typePoseOptions: [
        { value: "en combles perdu", text: "en combles perdu" },
        { value: "en rampant de toitures", text: "en rampant de toitures" },
      ],
      typeIsolantOptions: [
        { value: null, text: "Sélectionnez type", disabled: true },
        { value: "non reflechissant", text: "non reflechissant" },
        { value: "reflechissant", text: "reflechissant" },
      ],
      normesByType: {
        reflechissant: [{ value: "NF EN 16012+A1", text: "NF EN 16012+A1" }],
        "non reflechissant": [
          { value: "NF EN 12664", text: "NF EN 12664" },
          { value: "NF EN 12667", text: "NF EN 12667" },
          { value: "NF EN 12939", text: "NF EN 12939" },
        ],
      },
      protectionOptions: [
        { value: "A", text: "Pare-vapeur" },
        { value: "B", text: "Autre" },
      ],
      typeFenetreOptions: [
        { value: "fenêtre(s) de toiture", text: "fenêtre(s) de toiture" },
        { value: "double(s) fenêtre(s)", text: "double(s) fenêtre(s)" },
        { value: "porte(s)-fenêtre(s)", text: "porte(s)-fenêtre(s)" },
        { value: "autre(s) fenêtre(s)", text: "autre(s) fenêtre(s)" },
      ],
      installationTypeOptions: [
        { value: "Installation collective", text: "Installation collective" },
        { value: "Installation individuelle", text: "Installation individuelle" },
      ],
      ventilationTypeOptions: [
        { value: "C", text: "VMC simple flux hygroréglable" },
        { value: "D", text: "VMBP (ventilation mécanique basse pression) simple flux hygroréglable" },
      ],
      typeInstallationOptions: [
        { value: null, text: "Sélectionnez type", disabled: true },
        { value: "sur air extrait", text: "sur air extrait" },
        { value: "autres types d'installations", text: "autres types d'installations" },
      ],
      certificationTypeOptions: [
        { value: "certification", text: "certification" },
        { value: "caracteristiques", text: "capteurs possèdent caractéristiques performances" },
      ],
      normeTypeOptions: [
        { value: "fondée", text: "fondée sur les normes" },
        { value: "autres", text: "Autres normes" },
      ],
      pompeTypeOptions: [
        { value: "moyenne", text: "Température Moyenne" },
        { value: "haute", text: "Température Haute" },
        { value: "basse", text: "Température Basse" },
      ],
      raccordeOptions: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      certificatOptions: [
        { text: "Avec certificats énergie", value: true },
        { text: "Sans certificats énergie", value: false },
      ],
      concerneOptions: [
        { text: "système de chauffage ne disposant pas de régulation.", value: "système de chauffage ne disposant pas de régulation." },
        { text: "système de régulation existant.", value: "système de régulation existant." },
      ],
      classOptions: [
        { value: "A", text: "Classe A" },
        { value: "B", text: "Classe B" },
      ],
      booleanOptions: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
    };
  },
  validations() {
    return {
      formData: {
        dateEngagement: { required },
        factureId: { required },
        datePrevuRealisation: { required },
      },
    };
  },
  methods: {
    ...mapActions(["devis", "updateAH", "getOneAH", "all_entreprises"]),
    validateState(name) {
      const { $dirty, $error } = this.v$.formData[name];
      return $dirty ? !$error : null;
    },
    formatDateForInput(dateString) {
      if (!dateString) return null;
      // Convertir le format ISO (2025-10-30T00:00:00.000000Z) en format YYYY-MM-DD pour les inputs date
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    goBack() {
      this.$router.push("/AH");
    },
    async loadFactures() {
      try {
        const params = {
          page: 1,
          per_page: 100000000,
          type: "facture",
          brouillon: 0,
          // En mode édition, ne pas filtrer par ah pour permettre de voir la facture actuelle
          // ah: 0, // Filtrer les factures sans AH associé (0 = false)
        };
        
        // Si super admin, utiliser l'entreprise sélectionnée
        if (this.isSuperAdmin) {
          if (this.selectedEntreprise) {
            params.entreprise_id = this.selectedEntreprise;
          }
        } else {
          // Sinon, utiliser l'entreprise de l'utilisateur connecté
          if (this.getOnlineUser.entreprise) {
            if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
              params.entreprise_id = this.getOnlineUser.entreprise.id;
            } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
              params.entreprise_id = this.getOnlineUser.entreprise;
            } else {
              params.entreprise = this.getOnlineUser.entreprise;
            }
          }
        }
        
        await this.devis(params);
      } catch (error) {
        console.error("Error loading factures:", error);
      }
    },
    async onEntrepriseChange() {
      // Réinitialiser la facture sélectionnée quand l'entreprise change
      this.formData.factureId = null;
      this.selectedFactureGroups = [];
      this.factureDetails = null;
      this.groupFormData = {};
      // Recharger les factures pour la nouvelle entreprise
      await this.loadFactures();
    },
    async loadAH() {
      try {
        const response = await this.getOneAH(this.ahId);
        if (response && response.data) {
          const ah = response.data;
          this.ahData = ah; // Store full data for relations
          this.formData.factureId = ah.facture_id;
          this.formData.dateEngagement = this.formatDateForInput(
            ah.engagement_date || ah.date_engagement
          );
          this.formData.datePrevuRealisation = this.formatDateForInput(
            ah.completion_date || ah.date_prevu_realisation
          );
          this.formData.mentionsFinales =
            ah.mentions_finales || ah.mentionsFinales || "";
          this.formData.attestationBeneficiaire =
            ah.attestation_beneficiaire || ah.attestationBeneficiaire || "";
          this.formData.attestationProfessionnel =
            ah.attestation_professionnel || ah.attestationProfessionnel || "";
          
          // Si super admin, définir l'entreprise sélectionnée depuis la facture
          if (this.isSuperAdmin && ah.devis && ah.devis.entreprise) {
            this.selectedEntreprise = ah.devis.entreprise.id;
            // Recharger les factures pour cette entreprise
            await this.loadFactures();
          }
          
          // Detect existing relations and create groups
          this.detectAndCreateGroupsFromRelations(ah);
        }
      } catch (error) {
        console.error("Error loading AH:", error);
        alert(error?.response?.data?.message || error?.message || "Erreur lors du chargement de l'engagement.");
        this.goBack();
      }
    },
    // Map API relations to group types
    getRelationToGroupTypeMapping() {
      return {
        'isolation_combles_toiture': 'BAR-EN-101',
        'isolation_murs': 'BAR-EN-102',
        'isolation_plancher': 'BAR-EN-103',
        'fenetre_vitrage_complet': 'BAR-EN-104',
        'systeme_ventilation_mecanique_controlee': 'BAR-TH-127',
        'chauffe_eau_thermodynamiques': 'BAR-TH-148',
        'systeme_solaire': 'BAR-TH-143',
        'systeme_solaire_combinee': 'BAR-TH-143', // Alternative name
        'systeme_chauffage': 'BAR-TH-171',
        'pompe_chaleur_air_air': 'BAR-TH-129',
        'raccordement_residentiel_reseau_chaleur': 'BAR-TH-137',
        'raccordement_batiment_residentiel_reseau_chaleur': 'BAR-TH-137', // Alternative name
        'systeme_regulation_horaire': 'BAR-TH-173',
      };
    },
    // Detect existing relations and create virtual groups
    detectAndCreateGroupsFromRelations(ah) {
      this.selectedFactureGroups = [];
      this.groupFormData = {};
      
      const relationMapping = this.getRelationToGroupTypeMapping();
      
      // Check each relation
      Object.keys(relationMapping).forEach((relationName) => {
        const relationData = ah[relationName];
        const typeGroup = relationMapping[relationName];
        
        // If relation exists and has data (array with at least one item)
        if (Array.isArray(relationData) && relationData.length > 0) {
          // Create a virtual group for each item in the relation
          relationData.forEach((item, index) => {
            const groupId = `relation-${relationName}-${item.id || index}`;
            const virtualGroup = {
              id: groupId,
              type_group: typeGroup,
              relationName: relationName,
              relationItemId: item.id || null,
            };
            
            this.selectedFactureGroups.push(virtualGroup);
            
            // Initialize form data with existing data
            this.initializeGroupFormDataFromRelation(virtualGroup, item);
          });
        }
      });
      
      console.log('Detected groups from relations:', this.selectedFactureGroups);
      console.log('Group form data:', this.groupFormData);
    },
    // Initialize group form data from relation item
    initializeGroupFormDataFromRelation(group, relationItem) {
      const baseFormData = {
        donnees_supplementaires: relationItem?.donnees_supplementaires || "",
      };
      
      // Map relation data to form data based on group type
      switch (group.type_group) {
        case 'BAR-EN-101':
          Object.assign(baseFormData, {
            necessite_pare_vapeur: relationItem?.necessite_pare_vapeur ?? 0,
            type_pose: relationItem?.type_pose || null,
            type_isolant: relationItem?.type_isolant || null,
            norme: relationItem?.norme || null,
            surface_isolant: relationItem?.surface_isolant || "",
            resistance_thermique: relationItem?.resistance_thermique || "",
            epaisseur: relationItem?.epaisseur || "",
          });
          
          break;
        case 'BAR-EN-102':
          Object.assign(baseFormData, {
            type_isolant: relationItem?.type_isolant || null,
            norme: relationItem?.norme || null,
            Surface_isolant: relationItem?.Surface_isolant || "",
            resistance_thermique: relationItem?.resistance_thermique || "",
            epaisseur: relationItem?.epaisseur || "",
          });
          break;
        case 'BAR-EN-103':
          Object.assign(baseFormData, {
            protection_type: relationItem?.protection_type || "A",
            type_isolant: relationItem?.type_isolant || null,
            norme: relationItem?.norme || null,
            surface_isolant: relationItem?.surface_isolant || "",
            resistance_thermique: relationItem?.resistance_thermique || "",
            epaisseur: relationItem?.epaisseur || "",
          });
          break;
        case 'BAR-EN-104':
          Object.assign(baseFormData, {
            type_fenetre: relationItem?.type_fenetre || null,
            nombre_fenetres: relationItem?.nombre_fenetres || "",
            surface_totale: relationItem?.surface_totale || "",
            coefficient_transmission: relationItem?.coefficient_transmission || "",
            facteur_solaire: relationItem?.facteur_solaire || "",
          });
          break;
        case 'BAR-TH-127':
          Object.assign(baseFormData, {
            type_installation: relationItem?.type_installation || relationItem?.type || "Installation collective",
            type_ventilation: relationItem?.type_ventilation || relationItem?.type || "C",
            nombre_logements: relationItem?.nombre_logements || "",
            surface_habitable: relationItem?.surface_habitable || "",
            classe_energetique: relationItem?.classe_energetique || relationItem?.classe || "",
            puissance_electrique: relationItem?.puissance_electrique || "",
          });
          break;
        case 'BAR-TH-148':
          Object.assign(baseFormData, {
            type_installation: relationItem?.type_installation || null,
            cop: relationItem?.cop || "",
          });
          break;
        case 'BAR-TH-143':
          Object.assign(baseFormData, {
            certification_type: relationItem?.certification_type || "certification",
            norme_type: relationItem?.norme_type || "fondée",
            certification: relationItem?.certification || "",
            nature_fluide: relationItem?.nature_fluide || "",
            productivite: relationItem?.productivite || "",
            surface_chaufe: relationItem?.surface_chaufe || "",
            surface_hors_tout: relationItem?.surface_hors_tout || "",
            capacite_stockage: relationItem?.capacite_stockage || "",
            classe_efficacite_energetique: relationItem?.classe_efficacite_energetique || "",
          });
          break;
        case 'BAR-TH-171':
          Object.assign(baseFormData, {
            denomination_temperature: relationItem?.denomination_temperature || null,
            coefficient_performance: relationItem?.coefficient_performance || "",
            efficacite: relationItem?.efficacite || "",
            surface_chauffee: relationItem?.surface_chauffee || "",
            regulateur_classe: relationItem?.regulateur_classe || "",
          });
          break;
        case 'BAR-TH-129':
          Object.assign(baseFormData, {
            coefficient_performance_saisonnier: relationItem?.coefficient_performance_saisonnier || "",
            puissance_nominale: relationItem?.puissance_nominale || "",
            surface_chauffee: relationItem?.surface_chauffee || "",
          });
          break;
        case 'BAR-TH-137':
          Object.assign(baseFormData, {
            deja_raccorder: relationItem?.deja_raccorder ?? true,
            existe_cetificat_economie: relationItem?.existe_cetificat_economie ?? false,
            nbr_appartements: relationItem?.nbr_appartements || "",
            nom_reseau: relationItem?.nom_reseau || "",
            surface_habitable: relationItem?.surface_habitable || "",
          });
          break;
        case 'BAR-TH-173':
          Object.assign(baseFormData, {
            concerne: relationItem?.concerne || "système de chauffage ne disposant pas de régulation.",
            class: relationItem?.class || "A",
            ancient_system_class_c: relationItem?.ancient_system_class_c ?? true,
            pieces_equipees_emetteur: relationItem?.pieces_equipees_emetteur ?? true,
            comporte_appareil_central: relationItem?.comporte_appareil_central ?? true,
            dispose_sonde_mesure: relationItem?.dispose_sonde_mesure ?? true,
            possede_dispositif_regulant: relationItem?.possede_dispositif_regulant ?? true,
            effectuer_local_minima: relationItem?.effectuer_local_minima ?? true,
            deroger_localement_consignes: relationItem?.deroger_localement_consignes ?? true,
            fonctionner_perte_connexion: relationItem?.fonctionner_perte_connexion ?? true,
            logement_equipees_emetteur: relationItem?.logement_equipees_emetteur ?? true,
            planchers_plafonds_chauffants: relationItem?.planchers_plafonds_chauffants ?? true,
            remlpacement: relationItem?.remlpacement ?? true,
            surface_chauffe: relationItem?.surface_chauffe || "",
          });
          break;
      }
      
      this.groupFormData[group.id] = baseFormData;
    },
    getNormeOptions(groupId) {
      const typeIsolant = this.groupFormData[groupId]?.type_isolant;
      return typeIsolant ? this.normesByType[typeIsolant] || [] : [];
    },
    updateNormeOptions(groupId) {
      // Reset norme when type_isolant changes
      if (this.groupFormData[groupId]) {
        this.groupFormData[groupId].norme = null;
      }
    },
    getLogementType() {
      // Get from facture details if available
      return this.ahData?.devis?.logement?.type || "Maison individuelle";
    },
    getGroupLabel(typeGroup) {
      const labelMap = {
        "BAR-EN-101": this.$t("Isolation de combles ou de toiture") || "Isolation de combles ou de toiture",
        "BAR-EN-102": this.$t("Isolation des murs") || "Isolation des murs",
        "BAR-EN-103": this.$t("Isolation d'un plancher") || "Isolation d'un plancher",
        "BAR-EN-104": this.$t("Fenêtre ou porte-fenêtre complète avec vitrage isolant") || "Fenêtre ou porte-fenêtre complète avec vitrage isolant",
        "BAR-TH-127": this.$t("Ventilation mécanique simple flux hygroréglable") || "Ventilation mécanique simple flux hygroréglable",
        "BAR-TH-148": this.$t("Chauffe-eau thermodynamique à accumulation") || "Chauffe-eau thermodynamique à accumulation",
        "BAR-TH-143": this.$t("Système solaire") || "Système solaire",
        "BAR-TH-171": this.$t("Pompe à chaleur de type air/eau") || "Pompe à chaleur de type air/eau",
        "BAR-TH-129": this.$t("Pompe à chaleur de type air/air") || "Pompe à chaleur de type air/air",
        "BAR-TH-137": this.$t("Raccordement au réseau de chaleur") || "Raccordement au réseau de chaleur",
        "BAR-TH-173": this.$t("Système de régulation horaire") || "Système de régulation horaire",
      };
      return labelMap[typeGroup] || typeGroup;
    },
    async handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        // Collect group form data with type_group for each group
        const groupsData = {};
        Object.keys(this.groupFormData).forEach((groupId) => {
          // Find the corresponding group to get its type_group
          const group = this.selectedFactureGroups.find(g => g.id == groupId);
          groupsData[groupId] = {
            ...this.groupFormData[groupId],
            type_group: group?.type_group || null, // Add type_group to each group
          };
        });

        // Déterminer l'entreprise_id à utiliser
        let entrepriseId = null;
        if (this.isSuperAdmin) {
          if (this.selectedEntreprise) {
            entrepriseId = this.selectedEntreprise;
          }
        } else {
          if (this.getOnlineUser.entreprise) {
            if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
              entrepriseId = this.getOnlineUser.entreprise.id;
            } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
              entrepriseId = this.getOnlineUser.entreprise;
            }
          }
        }

        const payload = {
          facture_id: this.formData.factureId,
          engagement_date: this.formData.dateEngagement,
          completion_date: this.formData.datePrevuRealisation,
          entreprise_id: entrepriseId, // ID de l'entreprise
          mentions_finales: this.formData.mentionsFinales || null,
          attestation_beneficiaire: this.formData.attestationBeneficiaire || null,
          attestation_professionnel: this.formData.attestationProfessionnel || null,
          groups_data: Object.keys(groupsData).length > 0 ? groupsData : undefined, // Include groups_data if exists
        };

        console.log('Payload sent to updateAH:', payload);

        await this.updateAH({ id: this.ahId, ...payload });
        
        // Rediriger vers la liste après succès
        this.$router.push("/AH");
      } catch (error) {
        console.error("Error updating AH:", error);
        alert(error?.response?.data?.message || error?.message || "Une erreur est survenue lors de la mise à jour.");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getAlldevis",
      "getdevisLoading",
      "getTabs",
      "getOnlineUser",
      "getAHLoading",
      "getAllentreprises",
      "getentrepriseLoading",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser && this.getOnlineUser.role == "user.super-admin";
    },
    entrepriseOptions() {
      if (!this.getAllentreprises || !Array.isArray(this.getAllentreprises)) {
        return [];
      }
      return this.getAllentreprises.map((entreprise) => ({
        value: entreprise.id,
        text: entreprise.lib,
      }));
    },
    factureOptions() {
      let options = [];
      
      // Mapper les factures de getAlldevis
      if (this.getAlldevis && Array.isArray(this.getAlldevis)) {
        options = this.getAlldevis.map((item) => {
          const devis = item.devis || {};
          // Utiliser numerofacture si disponible, sinon numerodevis
          const number = devis.numerofacture || devis.numerodevis || `#${item.id}`;
          const clientName = devis.client 
            ? `${devis.client.prenom || ""} ${devis.client.nom || ""}`.trim()
            : "";
          const entrepriseName = item.entreprise ? item.entreprise.lib : "";
          const displayText = clientName 
            ? `${number} - ${clientName}${entrepriseName ? ` (${entrepriseName})` : ""}`
            : `${number}${entrepriseName ? ` - ${entrepriseName}` : ""}`;
          return {
            // Utiliser l'ID du devis (item.devis.id) et non l'ID du document (item.id)
            // car l'API attend l'ID du devis pour les factures
            value: item.devis ? item.devis.id : item.id, // ID du devis
            text: displayText,
            factureData: item, // Stocker les données complètes pour l'affichage
          };
        });
      }
      
      // Si la facture actuelle de l'AH n'est pas dans la liste, l'ajouter
      if (this.ahData && this.ahData.facture_id && this.ahData.devis) {
        const currentFactureId = this.ahData.devis.id;
        const isAlreadyInOptions = options.some(opt => opt.value === currentFactureId);
        
        if (!isAlreadyInOptions) {
          const devis = this.ahData.devis || {};
          const number = devis.numerofacture || devis.numerodevis || `#${devis.id || this.ahData.facture_id}`;
          const clientName = devis.client 
            ? `${devis.client.prenom || ""} ${devis.client.nom || ""}`.trim()
            : "";
          const entrepriseName = this.ahData.devis?.entreprise ? this.ahData.devis.entreprise.lib : "";
          const displayText = clientName 
            ? `${number} - ${clientName}${entrepriseName ? ` (${entrepriseName})` : ""}`
            : `${number}${entrepriseName ? ` - ${entrepriseName}` : ""}`;
          
          options.unshift({
            value: currentFactureId,
            text: displayText,
            factureData: {
              id: this.ahData.facture_id,
              devis: devis,
              entreprise: this.ahData.devis?.entreprise,
            },
          });
        }
      }
      
      return options;
    },
    selectedFactureInfo() {
      if (!this.formData.factureId) {
        return null;
      }
      const selectedOption = this.factureOptions.find(
        (opt) => opt.value === this.formData.factureId
      );
      if (!selectedOption || !selectedOption.factureData) {
        return null;
      }
      const facture = selectedOption.factureData;
      const devis = facture.devis || {};
      return {
        factureNumber: devis.numerofacture || devis.numerodevis || `#${facture.id}`,
        clientName: devis.client
          ? `${devis.client.prenom || ""} ${devis.client.nom || ""}`.trim()
          : null,
        entrepriseName: facture.entreprise ? facture.entreprise.lib : null,
      };
    },
    factureNumberDisplay() {
      if (this.ahData && this.ahData.devis) {
        const devis = this.ahData.devis;
        return devis.numerofacture || devis.numerodevis || `#${devis.id || this.ahData.facture_id}` || '-';
      }
      return '-';
    },
  },
  async mounted() {
    this.ahId = this.$route.params.id;
    if (!this.ahId) {
      this.goBack();
      return;
    }
    
    // Charger les entreprises si super admin
    if (this.isSuperAdmin) {
      await this.all_entreprises({
        page: 1,
        per_page: 1000,
      });
    }
    
    // Charger l'AH d'abord pour obtenir l'entreprise et la facture
    await this.loadAH();
    // Ensuite charger les factures avec l'entreprise correcte
    await this.loadFactures();
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}

.button-danger-style {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #fff;
}

.button-danger-style:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.facture-info {
  .info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    padding: 4px 0;
    border-bottom: 1px solid #dee2e6;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    strong {
      color: #28367a;
      margin-right: 10px;
    }

    span {
      color: #515151;
    }
  }
}

.conditional-forms {
  margin-top: 20px;
}

.form-group-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  background-color: #f8f9fa;
}

.group-header {
  h4 {
    color: #24316d;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #24316d;
  }
}
</style>

